"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const button_1 = require("./input/button");
exports.ErrorLayout = (0, react_1.memo)(({ errorMessage, onRetry }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", alignItems: "center", justifyContent: "center", spacing: 2, height: "100%", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", color: "error", children: errorMessage }), onRetry && ((0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", onClick: onRetry, children: "Retry" }))] }));
});
exports.ErrorLayout.displayName = "ErrorLayout";
